import { createSelector } from 'reselect';

const selectBranches = (state: any) => state.branches;


export const selectBranchesCurrentItem = createSelector([selectBranches], (branches) => branches.current);

export const selectBranchesListItems = createSelector([selectBranches], (branches) => branches.list);

export const selectBranchesItemById = (itemId: any) =>
    createSelector(selectBranchesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectBranchesQueryItems = createSelector([selectBranches], (branches) => branches.query);

export const selectBranchesCreatedItem = createSelector([selectBranches], (branches) => branches.create);

export const selectBranchesUpdatedItem = createSelector([selectBranches], (branches) => branches.update);

export const selectBranchesReadItem = createSelector([selectBranches], (branches) => branches.read);

export const selectBranchesDeletedItem = createSelector([selectBranches], (branches) => branches.delete);

export const selectBranchesSearchedItems = createSelector([selectBranches], (branches) => branches.search);

export const selectBranchesItemsCount = createSelector([selectBranches], (branches) => branches.count);

export const selectBranchesItemsFilter = createSelector([selectBranches], (branches) => branches.filter);